import React from 'react';
import { Loader2 } from 'lucide-react';
import { useLanguage, SUPPORTED_LANGUAGES } from '../contexts/LanguageContext';

/* Floating "Translating…" pill — shows whenever a TranslatedPage is fetching
 * uncached strings for the active language. Auto-hides as soon as inflight
 * count drops to zero.
 *
 * Positioned bottom-left so it doesn't fight with the FloatingDonateTab
 * (bottom-right). Pointer-events disabled so it never blocks clicks.
 */
const TranslationStatusPill = () => {
  const { isTranslating, lang } = useLanguage();
  if (!isTranslating || lang === 'en') return null;
  const langInfo = SUPPORTED_LANGUAGES.find((l) => l.code === lang) || {};
  return (
    <div
      className="fixed bottom-4 left-4 z-40 pointer-events-none animate-fade-in"
      data-testid="translation-status-pill"
    >
      <div className="inline-flex items-center gap-2 bg-[#0A0A0A] text-white text-xs font-semibold px-3 py-1.5 rounded-full shadow-lg">
        <Loader2 className="w-3 h-3 animate-spin" />
        <span>Translating to {langInfo.native || lang}…</span>
      </div>
    </div>
  );
};

export default TranslationStatusPill;
